// This file is AUTOGENERATED, do not edit it manually!!!

import { messageBoard as messageBoardde } from './messageBoardResx.de';
import { messageBoard as messageBoarden } from './messageBoardResx.en';
import { messageBoard as messageBoarden_risk } from './messageBoardResx.en_risk';
import { messageBoard as messageBoardes } from './messageBoardResx.es';
import { messageBoard as messageBoardfr } from './messageBoardResx.fr';
import { messageBoard as messageBoardit } from './messageBoardResx.it';
import { messageBoard as messageBoardnl } from './messageBoardResx.nl';
import { messageBoard as messageBoardpl } from './messageBoardResx.pl';
import { messageBoard as messageBoardpt } from './messageBoardResx.pt';
import { messageBoard as messageBoardru } from './messageBoardResx.ru';
import { messageBoard as messageBoardsk } from './messageBoardResx.sk';
import { messageBoard as messageBoardsv } from './messageBoardResx.sv';
import { messageBoard as messageBoardtr } from './messageBoardResx.tr';

const langMap: { [k: string]: Partial<typeof messageBoarden> } = {
    de: messageBoardde,
    en: messageBoarden,
    en_risk: messageBoarden_risk,
    es: messageBoardes,
    fr: messageBoardfr,
    it: messageBoardit,
    nl: messageBoardnl,
    pl: messageBoardpl,
    pt: messageBoardpt,
    ru: messageBoardru,
    sk: messageBoardsk,
    sv: messageBoardsv,
    tr: messageBoardtr,
};

/* tslint:disable: max-line-length */
export const messageBoardResx = {
    get add_message_button() {
        return langMap[ep.resxCulture].add_message_button || langMap.en.add_message_button;
    },
    get AdditionalRecipients() {
        return langMap[ep.resxCulture].AdditionalRecipients || langMap.en.AdditionalRecipients;
    },
    get Ai_disabled_button() {
        return langMap[ep.resxCulture].Ai_disabled_button || langMap.en.Ai_disabled_button;
    },
    get Append() {
        return langMap[ep.resxCulture].Append || langMap.en.Append;
    },
    get Apply() {
        return langMap[ep.resxCulture].Apply || langMap.en.Apply;
    },
    get approval_request_approved_comment() {
        return langMap[ep.resxCulture].approval_request_approved_comment || langMap.en.approval_request_approved_comment;
    },
    get approval_request_link() {
        return langMap[ep.resxCulture].approval_request_link || langMap.en.approval_request_link;
    },
    get approval_request_reject_comment() {
        return langMap[ep.resxCulture].approval_request_reject_comment || langMap.en.approval_request_reject_comment;
    },
    get Approve() {
        return langMap[ep.resxCulture].Approve || langMap.en.Approve;
    },
    get Approver_Approved() {
        return langMap[ep.resxCulture].Approver_Approved || langMap.en.Approver_Approved;
    },
    get Approver_HasNotSeen() {
        return langMap[ep.resxCulture].Approver_HasNotSeen || langMap.en.Approver_HasNotSeen;
    },
    get Approver_NoAction() {
        return langMap[ep.resxCulture].Approver_NoAction || langMap.en.Approver_NoAction;
    },
    get Approver_NotApproved() {
        return langMap[ep.resxCulture].Approver_NotApproved || langMap.en.Approver_NotApproved;
    },
    get Approver_Rejected() {
        return langMap[ep.resxCulture].Approver_Rejected || langMap.en.Approver_Rejected;
    },
    get ApproversGroupTitle() {
        return langMap[ep.resxCulture].ApproversGroupTitle || langMap.en.ApproversGroupTitle;
    },
    get Attachment_Delete() {
        return langMap[ep.resxCulture].Attachment_Delete || langMap.en.Attachment_Delete;
    },
    get BaseNotificationRule() {
        return langMap[ep.resxCulture].BaseNotificationRule || langMap.en.BaseNotificationRule;
    },
    get BeforePageUnloadMessage() {
        return langMap[ep.resxCulture].BeforePageUnloadMessage || langMap.en.BeforePageUnloadMessage;
    },
    get Cancel() {
        return langMap[ep.resxCulture].Cancel || langMap.en.Cancel;
    },
    get ChangeTone() {
        return langMap[ep.resxCulture].ChangeTone || langMap.en.ChangeTone;
    },
    get Close() {
        return langMap[ep.resxCulture].Close || langMap.en.Close;
    },
    get ContactAdministrator() {
        return langMap[ep.resxCulture].ContactAdministrator || langMap.en.ContactAdministrator;
    },
    get ContinueWriting() {
        return langMap[ep.resxCulture].ContinueWriting || langMap.en.ContinueWriting;
    },
    get Delete() {
        return langMap[ep.resxCulture].Delete || langMap.en.Delete;
    },
    get DeleteAttachmentContentTemplate() {
        return langMap[ep.resxCulture].DeleteAttachmentContentTemplate || langMap.en.DeleteAttachmentContentTemplate;
    },
    get DeleteAttachmentTitle() {
        return langMap[ep.resxCulture].DeleteAttachmentTitle || langMap.en.DeleteAttachmentTitle;
    },
    get Discard() {
        return langMap[ep.resxCulture].Discard || langMap.en.Discard;
    },
    get Download() {
        return langMap[ep.resxCulture].Download || langMap.en.Download;
    },
    get DropHere() {
        return langMap[ep.resxCulture].DropHere || langMap.en.DropHere;
    },
    get Edit() {
        return langMap[ep.resxCulture].Edit || langMap.en.Edit;
    },
    get edit_actions() {
        return langMap[ep.resxCulture].edit_actions || langMap.en.edit_actions;
    },
    get email_only_mention_title() {
        return langMap[ep.resxCulture].email_only_mention_title || langMap.en.email_only_mention_title;
    },
    get Error() {
        return langMap[ep.resxCulture].Error || langMap.en.Error;
    },
    get FilePlural() {
        return langMap[ep.resxCulture].FilePlural || langMap.en.FilePlural;
    },
    get FileUploadError() {
        return langMap[ep.resxCulture].FileUploadError || langMap.en.FileUploadError;
    },
    get FileVersion() {
        return langMap[ep.resxCulture].FileVersion || langMap.en.FileVersion;
    },
    get FileVersionShort() {
        return langMap[ep.resxCulture].FileVersionShort || langMap.en.FileVersionShort;
    },
    get Formal() {
        return langMap[ep.resxCulture].Formal || langMap.en.Formal;
    },
    get FreeSpaceTemplate() {
        return langMap[ep.resxCulture].FreeSpaceTemplate || langMap.en.FreeSpaceTemplate;
    },
    get Friendly() {
        return langMap[ep.resxCulture].Friendly || langMap.en.Friendly;
    },
    get GeneratedByAi() {
        return langMap[ep.resxCulture].GeneratedByAi || langMap.en.GeneratedByAi;
    },
    get HideFiles() {
        return langMap[ep.resxCulture].HideFiles || langMap.en.HideFiles;
    },
    get ImproveSpelling() {
        return langMap[ep.resxCulture].ImproveSpelling || langMap.en.ImproveSpelling;
    },
    get ImproveWriting() {
        return langMap[ep.resxCulture].ImproveWriting || langMap.en.ImproveWriting;
    },
    get mention_title() {
        return langMap[ep.resxCulture].mention_title || langMap.en.mention_title;
    },
    get Message_Delete() {
        return langMap[ep.resxCulture].Message_Delete || langMap.en.Message_Delete;
    },
    get message_maxLength_description() {
        return langMap[ep.resxCulture].message_maxLength_description || langMap.en.message_maxLength_description;
    },
    get message_maxLength_title() {
        return langMap[ep.resxCulture].message_maxLength_title || langMap.en.message_maxLength_title;
    },
    get MessageDeleteConfirmation() {
        return langMap[ep.resxCulture].MessageDeleteConfirmation || langMap.en.MessageDeleteConfirmation;
    },
    get messageEdited() {
        return langMap[ep.resxCulture].messageEdited || langMap.en.messageEdited;
    },
    get MessageEditedBy() {
        return langMap[ep.resxCulture].MessageEditedBy || langMap.en.MessageEditedBy;
    },
    get messagePlaceholderText() {
        return langMap[ep.resxCulture].messagePlaceholderText || langMap.en.messagePlaceholderText;
    },
    get MultipleApproversTemplate() {
        return langMap[ep.resxCulture].MultipleApproversTemplate || langMap.en.MultipleApproversTemplate;
    },
    get MyComputer() {
        return langMap[ep.resxCulture].MyComputer || langMap.en.MyComputer;
    },
    get NewMessageWatermark() {
        return langMap[ep.resxCulture].NewMessageWatermark || langMap.en.NewMessageWatermark;
    },
    get NewPost() {
        return langMap[ep.resxCulture].NewPost || langMap.en.NewPost;
    },
    get No() {
        return langMap[ep.resxCulture].No || langMap.en.No;
    },
    get NoMatchRecipients() {
        return langMap[ep.resxCulture].NoMatchRecipients || langMap.en.NoMatchRecipients;
    },
    get NoPermissionToEditMessage() {
        return langMap[ep.resxCulture].NoPermissionToEditMessage || langMap.en.NoPermissionToEditMessage;
    },
    get Notification() {
        return langMap[ep.resxCulture].Notification || langMap.en.Notification;
    },
    get Notify() {
        return langMap[ep.resxCulture].Notify || langMap.en.Notify;
    },
    get NotifyLabel() {
        return langMap[ep.resxCulture].NotifyLabel || langMap.en.NotifyLabel;
    },
    get NotProjectMembers() {
        return langMap[ep.resxCulture].NotProjectMembers || langMap.en.NotProjectMembers;
    },
    get OneDrive() {
        return langMap[ep.resxCulture].OneDrive || langMap.en.OneDrive;
    },
    get OneDriveFilePicker() {
        return langMap[ep.resxCulture].OneDriveFilePicker || langMap.en.OneDriveFilePicker;
    },
    get Optimistic() {
        return langMap[ep.resxCulture].Optimistic || langMap.en.Optimistic;
    },
    get Or() {
        return langMap[ep.resxCulture].Or || langMap.en.Or;
    },
    get PluralApproved() {
        return langMap[ep.resxCulture].PluralApproved || langMap.en.PluralApproved;
    },
    get PluralRejected() {
        return langMap[ep.resxCulture].PluralRejected || langMap.en.PluralRejected;
    },
    get Post() {
        return langMap[ep.resxCulture].Post || langMap.en.Post;
    },
    get PostWatingForApproval() {
        return langMap[ep.resxCulture].PostWatingForApproval || langMap.en.PostWatingForApproval;
    },
    get PreviewImages() {
        return langMap[ep.resxCulture].PreviewImages || langMap.en.PreviewImages;
    },
    get Professional() {
        return langMap[ep.resxCulture].Professional || langMap.en.Professional;
    },
    get ProjectMembers() {
        return langMap[ep.resxCulture].ProjectMembers || langMap.en.ProjectMembers;
    },
    get Reject() {
        return langMap[ep.resxCulture].Reject || langMap.en.Reject;
    },
    get Replace() {
        return langMap[ep.resxCulture].Replace || langMap.en.Replace;
    },
    get RequestApprovalLabel() {
        return langMap[ep.resxCulture].RequestApprovalLabel || langMap.en.RequestApprovalLabel;
    },
    get Retry() {
        return langMap[ep.resxCulture].Retry || langMap.en.Retry;
    },
    get SharePoint() {
        return langMap[ep.resxCulture].SharePoint || langMap.en.SharePoint;
    },
    get SharePointFilePicker() {
        return langMap[ep.resxCulture].SharePointFilePicker || langMap.en.SharePointFilePicker;
    },
    get ShowFiles() {
        return langMap[ep.resxCulture].ShowFiles || langMap.en.ShowFiles;
    },
    get ShowNext() {
        return langMap[ep.resxCulture].ShowNext || langMap.en.ShowNext;
    },
    get SingleApprovedTemplate() {
        return langMap[ep.resxCulture].SingleApprovedTemplate || langMap.en.SingleApprovedTemplate;
    },
    get SingleApprovedTemplate_You() {
        return langMap[ep.resxCulture].SingleApprovedTemplate_You || langMap.en.SingleApprovedTemplate_You;
    },
    get SingleApproverTemplate() {
        return langMap[ep.resxCulture].SingleApproverTemplate || langMap.en.SingleApproverTemplate;
    },
    get SingleRejectedTemplate() {
        return langMap[ep.resxCulture].SingleRejectedTemplate || langMap.en.SingleRejectedTemplate;
    },
    get SingleRejectedTemplate_You() {
        return langMap[ep.resxCulture].SingleRejectedTemplate_You || langMap.en.SingleRejectedTemplate_You;
    },
    get Straightforward() {
        return langMap[ep.resxCulture].Straightforward || langMap.en.Straightforward;
    },
    get Summarize() {
        return langMap[ep.resxCulture].Summarize || langMap.en.Summarize;
    },
    get SummarizeBulletPoints() {
        return langMap[ep.resxCulture].SummarizeBulletPoints || langMap.en.SummarizeBulletPoints;
    },
    get TabEvents() {
        return langMap[ep.resxCulture].TabEvents || langMap.en.TabEvents;
    },
    get TabFiles() {
        return langMap[ep.resxCulture].TabFiles || langMap.en.TabFiles;
    },
    get TabMessages() {
        return langMap[ep.resxCulture].TabMessages || langMap.en.TabMessages;
    },
    get Teams() {
        return langMap[ep.resxCulture].Teams || langMap.en.Teams;
    },
    get Undo() {
        return langMap[ep.resxCulture].Undo || langMap.en.Undo;
    },
    get UploadedBy() {
        return langMap[ep.resxCulture].UploadedBy || langMap.en.UploadedBy;
    },
    get Yes() {
        return langMap[ep.resxCulture].Yes || langMap.en.Yes;
    },
    get You() {
        return langMap[ep.resxCulture].You || langMap.en.You;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.messageBoard = messageBoardResx;
